import topbar from "../vendor/topbar";

// Show progress bar on live navigation and form submits. Only displays if still
// Loading after 150 msec
let topBarScheduled;

topbar.config({barColors: {0: "#a535cd"}, shadowColor: "rgba(0, 0, 0, .3)"})

window.addEventListener("phx:page-loading-start", () => {
  if (!topBarScheduled) {
    topBarScheduled = setTimeout(() => topbar.show(), 150);
  };
});

window.addEventListener("phx:page-loading-stop", () => {
  clearTimeout(topBarScheduled);
  topBarScheduled = null;
  topbar.hide();
});
